const $ = require('lib/jquery')
const Marionette = require('lib/marionette')
const Router = require('lib/router')
const radio = require('lib/radio')
const Raven = require('lib/raven')
const resendEmail = require('./resend')
const Dialog = require('module/dialog/dialog')
const log = require('log').create('verify email')  

const Verify = Marionette.MnObject.extend({
    initialize(options) {
        this.user = options.user
        this.metrics = radio.metrics

        this.initializeRouter()
    },

    appRoutes: {
        '': 'destroy',
        ':hash': 'verifyEmail',
    },

    initializeRouter() {
        this.router = new Router({
            controller: this,
            scope: `${this.user.get('user_name')}/verify`,
            appRoutes: this.appRoutes,
        })
    },

    verifyEmail(hash) {
        // don't need to verify in this case,
        // would just cause pain
        if (this.user.get('flags.email_verified')) {
            Dialog.banner('Your email address has already been verified.', { status: 'info' })
            this.destroy()
            return
        }

        $.ajax({
            type: 'POST',
            url: `${this.user.url()}/verify_email`,
            data: JSON.stringify({ hash }),
            dataType: 'json',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .done(res => {
                log('res', res)
                Dialog.banner(
                    'Your email address has been verified!',
                    {
                        status: 'confirmation',
                        duration: 10000,
                    },
                )

                this.user.set('flags.email_verified', true)
                this.metrics.trigger('email:verification:success')
            })
            .fail(err => {
                let msg
                log('err', err)

                $.body.one('click', '.banner .resend-verification-email', () => {
                    resendEmail({
                        user: this.user,
                    })
                })

                switch (err && err.type) {
                    case 'invalid-hash':
                        msg = 'That verification link is invalid or expired.'
                        break
                    default:
                        msg = 'There was a problem verifying your email address.'
                }

                msg += ' <span class="text link resend-verification-email">Resend email</span>.'

                Dialog.banner(msg, { status: 'error' })

                Raven.captureMessage('verify email failed', {
                    extra: {
                        err,
                    },
                })
            })
            .always(() => {
                this.destroy()
            })
    },

})

module.exports = Verify
